import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import t from '../../lib/I18n';

import Page from '../general/Page';

function StepHeader ({ number, label, active, className }) {
    const classes = classnames(
        'step-header', className, 'text-weight--normal',
        {
            'step-header--active': active
        }
    );
    return (
        <Page title={ label }>
            <h2 className={ classes }>
                <span className="step-header__number">
                    <span className="sr-only">{ t('global.step') } </span>
                    { number }
                    <span className="sr-only">. </span>
                </span>
                <legend className="step-header__legend">{ label }</legend>
            </h2>
        </Page>
    );
}

StepHeader.propTypes = {
    number: PropTypes.number,
    label: PropTypes.string,
    active: PropTypes.bool,
    className: PropTypes.string
};

StepHeader.defaultProps = {
    number: 0,
    label: '',
    active: false,
    className: ''
};

export default StepHeader;



// WEBPACK FOOTER //
// ./src/components/serviceList/StepHeader.js